import { render, staticRenderFns } from "./DbEstimateCost.vue?vue&type=template&id=5817b4f5&align=center&"
import script from "./DbEstimateCost.vue?vue&type=script&lang=js&"
export * from "./DbEstimateCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports